import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=44e6e8cc&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=44e6e8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6e8cc",
  null
  
)

component.options.__file = "PasswordReset.vue"
export default component.exports